import React, { useEffect } from "react";
import { Switch, Route, NavLink, useLocation } from "react-router-dom";
import { Icon, Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { canAdminSurveys } from "app/permissions";
import { isCurrentRoute, seo, t, Trans } from "app/utils";

import SurveysManage from "./SurveysManage";
import SurveysAvailable from "./SurveysAvailable";
import SurveysCompleted from "./SurveysCompleted";

const SurveyNavItem = ({ to, location, children }) => (
  <NavLink
    role="tab"
    aria-selected={isCurrentRoute(to, location, true)}
    to={to}
    exact
    activeClassName="active"
  >
    {children}
  </NavLink>
);

const Surveys = () => {
  const location = useLocation();
  const { profile } = useProfile();
  const canAdmin = canAdminSurveys(profile);

  useEffect(
    () => {
      seo({
        title: `${t("Surveys")} - CultureHQ.com`
      });
    }
  );

  return (
    <section role="main">
      <Panel limitWidth>
        <div role="tablist" aria-label={t("Surveys options")} className="Surveys__Nav">
          <SurveyNavItem to="/surveys" location={location}>
            <Trans>Available Surveys</Trans>
          </SurveyNavItem>
          <SurveyNavItem to="/surveys/completed" location={location}>
            <Trans>Completed Surveys</Trans>
          </SurveyNavItem>
          {canAdmin && (
            <SurveyNavItem to="/surveys/manage" location={location}>
              <Icon icon="ios-gear" />
              <Trans>Manage Surveys</Trans>
            </SurveyNavItem>
          )}
        </div>
        <Panel.Body>
          <Switch>
            <Route exact path="/surveys" component={SurveysAvailable} />
            <Route exact path="/surveys/completed/:page?" component={SurveysCompleted} />
            {canAdmin && (
              <Route exact path="/surveys/manage" component={SurveysManage} />
            )}
          </Switch>
        </Panel.Body>
      </Panel>
    </section>
  );
};

export default Surveys;
